import React from 'react';
import { Stack, Title, Text, Button } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

function UnauthorizedPage() {
  const navigate = useNavigate();
  return (
    <Stack align="center" justify="center" h="100vh" spacing="md">
      <Title order={2} color="red">You are not authorized to access this page.</Title>
      <Text>If this is a mistake, please reach out to customer support.</Text>
      <Button variant="outline" color="violet" onClick={() => navigate(-1)}>
        Go Back
      </Button>
    </Stack>
  );
}

export default UnauthorizedPage; 